import * as VisitorTracking from '../visitorTracking';
import { recordInterest, readLastInterest } from '../zahsLastInterest.js';

export function initializeEnrollNow() {
    function safeInitModal(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                return new Modal(element);
            }
            return null;  // Return null if element is not found
        }

    // find all elements with the class 'enroll-btn'
    // and add a click event listener to each
    document.querySelectorAll('.enroll-btn').forEach(button => {
        button.addEventListener('click', async function () {
            const enrollmentModal = safeInitModal('zoniModal');
            let program = button?.getAttribute('data-program') || '';
            let track   = button?.getAttribute('data-track')   || '';

            // persist if program is not empty.
            if (program) {
                recordInterest(program, track, location.pathname);
            } else {
                // attempt to read last interest
                last = readLastInterest(60);
                if (last) {
                    program = last.program || program;
                    track   = last.track   || track;
                }
            }

            // set hidden fields
            VisitorTracking.customizeSchoolEnrollment();
            if (program) {
                document.getElementById('zahs_program_interest').value = program;
                document.getElementById('zahs_track_interest').value = track;
            }
            enrollmentModal?.show();
        });
    });
}